import { ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MatFormFieldModule,
  MatInputModule,
  MatIconModule,
  MatButtonModule,
  MatCheckboxModule,
  MatTooltipModule,
  MatProgressSpinnerModule,
  MatDialogModule,
  MatMenuModule
} from '@angular/material';

import { SharedModule } from '../shared/shared.module';

import {LoginFormComponent} from './components/login-form/login-form.component';
import {AuthControlPanelComponent} from './components/auth-control-panel/auth-control-panel.component';
import {ResetPasswordComponent} from './components/reset-password/reset-password.component';
import {ForgotPasswordComponent} from './components/forgot-password/forgot-password.component';


@NgModule({

  declarations: [
    LoginFormComponent,
    AuthControlPanelComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent
  ],

  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatMenuModule
  ],

  exports: [LoginFormComponent, AuthControlPanelComponent],

  entryComponents: [ResetPasswordComponent],

})

export class AuthenticationModule { }
